module.exports = __webpack_public_path__ + "static/img/AD@2x.2a12bac6.jpg";